import { UXState, VariantComponent, Variant } from './types'

export function selectVariant(component: VariantComponent, state: UXState): Variant {
  const { persona, axes } = state

  switch (component) {
    case 'Hero':
      return persona === 'recruiter' ? 'RecruiterHero' : 'EngineerHero'

    case 'ProjectCard':
      // If density > 0.5, use compact TechnicalCard, else SummaryCard
      return axes.density > 0.5 ? 'TechnicalCard' : 'SummaryCard'

    case 'Skills':
      // If depth > 0.5, use DetailedTable, else BadgeList
      return axes.depth > 0.5 ? 'DetailedTable' : 'BadgeList'

    case 'ProjectDetail':
      return persona === 'recruiter' ? 'StoryLayout' : 'ArchLayout'

    default:
      return 'default'
  }
}

export function getMotionDuration(baseMs: number, axes: { motion: number }): number {
  // Scale animation duration based on motion axis
  // motion=0 → instant (0.01ms)
  // motion=0.5 → half duration
  // motion=1 → full duration
  if (axes.motion === 0) return 0.01
  return baseMs * axes.motion
}
